<template>
    <div :id="modalId" uk-modal class="employee-training-form">
        <div class="uk-modal-dialog uk-modal-body">
            <h2 class="uk-modal-title uk-margin-medium-bottom">Update Training</h2>
            <div class="uk-grid">
                <div class="uk-form-controls uk-width-2-3">
                    <label for="employee-training-modal-trainings" class="uk-form-label">Training</label>
                    <select id="employee-training-modal-trainings" class="uk-select " v-model="trainingId">
                        <option v-for="val in trainingOptions" :value="val.id" >{{val.name}}</option>
                    </select>
                </div>
                <div class="uk-form-controls uk-width-1-3">
                    <label class="uk-form-label">Completion Date</label>
                    <datepicker ref="completedDate" type="date" v-model="completed" v-on:input="completionDateSet" input-class="uk-input" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                </div>
            </div>
			<div class="uk-form-label uk-margin-small-top">Documents</div>
			<div class="employee-documents" v-for="doc in documents">
				<a :href="doc.url" target="_blank" v-if="renamingDocId!=doc.id" >{{ doc.name }}</a>
				<i class="fas fa-edit" @click="renameDoc(doc.id)" v-if="renamingDocId!=doc.id"></i>
				<input class="uk-input uk-width-5-6" type="text" v-model="doc.name" v-if="renamingDocId==doc.id" />
				<i class="fas fa-save" @click="updateDocName(doc.id, doc.name)" v-if="renamingDocId==doc.id"></i>
			</div>
            <div class="uk-margin-medium-bottom"></div>
            <button class="uk-button uk-button-primary uk-modal-close" type="button" @click="submitForm()">Finish</button>
            <button class="uk-button uk-button-tertiary uk-modal-close" type="button" @click="cancel()">Cancel</button>
        </div>
    </div>
</template>

<script>
    import EventBus from "../../events";
	import Datepicker from "vuejs-datepicker";
    export default {
        name: "EmployeeTrainingForm",
		components:{
			Datepicker
		},
        props:{
            uid:Number,
            modalId:String,
            tableRef:String
        },

        data(){
            return {
                personTrainingId:null,
                trainingOptions:[],
                trainingId:0,
                completed:"",
                completedDateString:"",
                docId: null,
                updateAfter: null,
				documents:[],
				renamingDocId:null
            }
        },

        mounted(){
            this.loadTrainings();
        },
        methods:{
            loadTrainings(){
                axios.get("/api/training/list/all?sort=name&dir=asc")
                    .then((pack) => this.updateTrainingData(pack));
            },
            loadForm(id){
                this.personTrainingId = id;
                axios.get("/api/employee/"+this.uid+"/training/" + id)
                    .then((pack) => this.formLoaded(pack));
            },
            formLoaded(pack){
                let dt = pack.data.data;
                this.trainingId = dt.training_id;
                this.completed = dt.completed;
				this.documents = dt.documents;
                this.$refs.completedDate.value = this.completed;
            },
            updateTrainingData(pack){
                let dt = pack.data.data;
                this.trainingOptions = dt;
            },
            submitForm(){
                if(!this.trainingId){
                    return;
                }
                let formData = new FormData();
                formData.append("training_id", this.trainingId);
                formData.append("completed", this.completedDateString);

                if(this.docId){
                    formData.append("doc_id", this.docId);
                }

                axios.post("/api/employee/"+this.uid+"/training" + (this.personTrainingId ? "/"+this.personTrainingId:""), formData)
                    .then((pack) => this.dataUpdated(pack));
            },
            dataUpdated(pack){
                if(this.$root.$refs[this.tableRef]){ //if the sidebar is closed, it won't be there
                    this.$root.$refs[this.tableRef].loadTrainings();
                }
                let chosenTraining = null;
                for(let i = 0; i < this.trainingOptions.length;++i){
                    if(this.trainingOptions[i].id == this.trainingId){
                        chosenTraining = this.trainingOptions[i];
                        break;
                    }
                }
                if(pack.data.success){
                    EventBus.fireEvent("message", chosenTraining.name + " added.");
                } else {
                    EventBus.fireEvent("error", chosenTraining.name + " could not be added.");
                }
                this.personTrainingId = null;
                this.trainingId = 0;
                this.completed = "";
                this.docId = null;
                if(this.updateAfter){
                    this.updateAfter.loadFiles();
                }
            },
            cancel(){
                if(this.personTrainingId){
                    this.personTrainingId = null;
                    this.trainingId = 0;
                    this.completed = "";
                    this.docId = null;
                    this.updateAfter = null;
                    this.documents = [];
                }

            },
            completionDateSet(val){
                this.completedDateString = (val.getUTCMonth() + 1) + "/" + val.getUTCDate() + "/" + val.getUTCFullYear();
            },
            loadDoc(id, caller){
                this.personTrainingId = null;
                this.docId = id;
                this.updateAfter = caller;

                axios.get("/api/employee/"+this.uid+"/file/" + this.docId).then(
					(pack) => this.loadExternalDoc(pack),
					(pack) => this.loadExternalDoc(pack)
				)
            },
			renameDoc(id){
				this.renamingDocId = id;
			},
			updateDocName(id, name){
				this.renamingDocId = null;
				axios.put("/api/employee-file/"+id+"/rename",{
					name: name
				}).then(
					(pack) => this.updateDoc(pack),
					(pack) => this.updateDoc(pack)
				)
			},
			updateDoc(pack){
				if(pack.data.success){
					let doc = pack.data.data;
					for(let i = 0; i < this.documents.length;++i){
						if(this.documents[i].id == doc.id){
							this.documents[i] = doc;
							this.$forceUpdate();
							break;
						}
					}
					if(this.updateAfter){
						this.updateAfter.loadFiles();
					}
				}
			},
			loadExternalDoc(pack){
				if(pack.data.success){
					this.documents = [pack.data.data];
				}
			}
        }
    }
</script>

<style scoped>

</style>
